/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css'
import './styles.scss'
import { TypescriptComponent } from 'components/typescriptExample'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import { Link } from '@ta-interaktiv/contentbricks'

// TODO Set the correct article ID here
const ARTICLE_ID = '806586117625'

const isMobileSmall = window.innerWidth < 375

export function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header className='ui vertical very fitted segment'>
        <div className='ui container'>
          <div className='ui header'>
            <h1>Die gefürchtete Grippewelle, die nie kam</h1>
            <h2>
              Länder, die den Winter hinter sich haben, verzeichneten praktisch
              keine Grippefälle dieses Jahr. Was bedeutet das für die
              Nordhalbkugel?
            </h2>
          </div>
        </div>
      </header>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta metainfo'>
            <div className='ta author'>Marc Brupbacher, Patrick Vögeli</div>
            <div className='ta updated'>Aktualisiert am 18. September 2020</div>
          </div>
          <div className='ta text'>
            <p>
              Der Winter auf der südlichen Hemisphäre neigt sich langsam dem
              Ende zu, und bemerkenswerterweise gab es weder in Australien,
              Neuseeland, Südafrika noch in weiten Teilen Südamerikas eine
              Grippewelle dieses Jahr. Es drängt sich die Vermutung auf, dass
              die strikten Massnahmen, welche überall auf der Welt im März im
              Kampf gegen Sars-CoV-2 eingeführt wurden, auch andere
              respiratorische Erkrankungen an der Verbreitung hinderten, unter
              anderem auch die Grippe, die jährlich bis zu 650’000 Personen
              tötet.
            </p>
            <p>
              Die Weltgesundheitsorganisation (WHO) überwacht in vielen Ländern
              zirkulierende Viren und arbeitet hierfür mit lokalen Labors
              zusammen, welche ständig Daten übermitteln. In den ersten beiden
              Augustwochen waren von 200’000 Grippetests, die der WHO gemeldet
              wurden, nur 46 positiv. In einem normalen Grippejahr beträgt diese
              Zahl rund 3500. Und es wurde nur leicht weniger getestet als in
              den Vorjahren. In Australien werden in einer gewöhnlichen
              Grippesaison 86’000 Personen positiv auf ein Influenza-Virus
              getestet, und es sterben 130 daran. In diesem Winter waren es
              lediglich 627 Fälle bei einem Todesfall.
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical segment'>
        <div className='ui container'>
          <div className='title'>
            Kaum Grippefälle auf der Südhalbkugel im&nbsp;2020
          </div>

          <div className='ui three column grid doubling stackable'>
            <div className='row'>
              <div className='column special'>
                <div className='titleBox'>
                  <h4 className='ui infographic header'>Argentinien&nbsp;🇦🇷</h4>
                </div>
                <div className='graphicBox'>
                  <div className='boxWrapper'>
                    <div className='iframeBox'>
                      <AutofitIFrame
                        src='//datawrapper.dwcdn.net/Uj754/'
                        style={{ height: '100%' }}
                      />
                    </div>
                  </div>
                  <table className='ui small very basic compact collapsing table barChart'>
                    <tbody>
                      <tr>
                        <td className='seven wide'></td>
                        <td className='nine wide small'>Tote pro 100'000</td>
                      </tr>
                      <tr className='flu'>
                        <td className='seven wide'>∅ Grippe 2015&#x2011;19</td>
                        <td className='nine wide'>
                          <div className='barContainer'>
                            <div className='barChartWrapper'>
                              <div
                                className='barFlu'
                                style={{ width: 25.7 + '%' }}
                              ></div>
                            </div>
                            <div
                              className='value'
                              style={{ paddingLeft: 22.7 + '%' }}
                            >
                              16,2
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr className='covid'>
                        <td className='seven wide'>Covid-19 2020</td>
                        <td className='nine wide'>
                          <div className='barContainer'>
                            <div className='barChartWrapper'>
                              <div
                                className='barCovid'
                                style={{ width: 42.5 + '%' }}
                              ></div>
                            </div>
                            <div
                              className='value'
                              style={{ paddingLeft: 35.4 + '%' }}
                            >
                              26,8
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className='column special'>
                <div className='titleBox'>
                  <h4 className='ui infographic header'>Australien&nbsp;🇦🇺</h4>
                </div>
                <div className='graphicBox'>
                  <div className='boxWrapper'>
                    <div className='iframeBox'>
                      <AutofitIFrame
                        src='//datawrapper.dwcdn.net/tKmET/'
                        style={{ height: '100%' }}
                      />
                    </div>
                  </div>
                  <table className='ui small very basic compact collapsing table barChart'>
                    <tbody>
                      <tr>
                        <td className='seven wide'></td>
                        <td className='nine wide small'>Tote pro 100'000</td>
                      </tr>
                      <tr className='flu'>
                        <td className='seven wide'>∅ Grippe 2015&#x2011;19</td>
                        <td className='nine wide'>
                          <div className='barContainer'>
                            <div className='barChartWrapper'>
                              <div
                                className='barFlu'
                                style={{ width: 3.5 + '%' }}
                              ></div>
                            </div>
                            <div
                              className='value'
                              style={{ paddingLeft: 5.8 + '%' }}
                            >
                              2,2
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr className='covid'>
                        <td className='seven wide'>Covid-19 2020</td>
                        <td className='nine wide'>
                          <div className='barContainer'>
                            <div className='barChartWrapper'>
                              <div
                                className='barCovid'
                                style={{ width: 5.2 + '%' }}
                              ></div>
                            </div>
                            <div
                              className='value'
                              style={{ paddingLeft: 7.5 + '%' }}
                            >
                              3,3
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className='column special'>
                <div className='titleBox'>
                  <h4 className='ui infographic header'>Chile&nbsp;🇨🇱</h4>
                </div>
                <div className='boxWrapper'>
                  <div className='iframeBox'>
                    <AutofitIFrame
                      src='//datawrapper.dwcdn.net/NKSRD/'
                      style={{ height: '100%' }}
                    />
                  </div>
                </div>
                <div className='graphicBox'>
                  <table className='ui small very basic compact collapsing table barChart'>
                    <tbody>
                      <tr>
                        <td className='seven wide'></td>
                        <td className='nine wide small'>Tote pro 100'000</td>
                      </tr>
                      <tr className='flu'>
                        <td className='seven wide'>∅ Grippe 2015&#x2011;19</td>
                        <td className='nine wide'>
                          <div className='barContainer'>
                            <div className='barChartWrapper'>
                              <div
                                className='barFlu'
                                style={{ width: 20.1 + '%' }}
                              ></div>
                            </div>
                            <div
                              className='value'
                              style={{ paddingLeft: 18.4 + '%' }}
                            >
                              12,7
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr className='covid'>
                        <td className='seven wide'>Covid-19 2020</td>
                        <td className='nine wide'>
                          <div className='barContainer'>
                            <div className='barChartWrapper'>
                              <div
                                className='barCovid'
                                style={{ width: 100 + '%' }}
                              ></div>
                            </div>
                            <div
                              className='value'
                              style={{ paddingLeft: 77.8 + '%' }}
                            >
                              63,1
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className='column special'>
                <div className='titleBox'>
                  <h4 className='ui infographic header'>Neuseeland&nbsp;🇳🇿</h4>
                </div>
                <div className='boxWrapper'>
                  <div className='iframeBox'>
                    <AutofitIFrame
                      src='//datawrapper.dwcdn.net/d91D5/'
                      style={{ height: '100%' }}
                    />
                  </div>
                </div>
                <div className='graphicBox'>
                  <table className='ui small very basic compact collapsing table barChart'>
                    <tbody>
                      <tr>
                        <td className='seven wide'></td>
                        <td className='nine wide small'>Tote pro 100'000</td>
                      </tr>
                      <tr className='flu'>
                        <td className='seven wide'>∅ Grippe 2015&#x2011;19</td>
                        <td className='nine wide'>
                          <div className='barContainer'>
                            <div className='barChartWrapper'>
                              <div
                                className='barFlu'
                                style={{ width: 5.2 + '%' }}
                              ></div>
                            </div>
                            <div
                              className='value'
                              style={{ paddingLeft: 7.4 + '%' }}
                            >
                              3,3
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr className='covid'>
                        <td className='seven wide'>Covid-19 2020</td>
                        <td className='nine wide'>
                          <div className='barContainer'>
                            <div className='barChartWrapper'>
                              <div
                                className='barCovid'
                                style={{ width: 0.8 + '%' }}
                              ></div>
                            </div>
                            <div
                              className='value'
                              style={{ paddingLeft: 4.8 + '%' }}
                            >
                              0,5
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className='column special'>
                <div className='titleBox'>
                  <h4 className='ui infographic header'>Paraguay&nbsp;🇵🇾</h4>
                </div>
                <div className='boxWrapper'>
                  <div className='iframeBox'>
                    <AutofitIFrame
                      src='//datawrapper.dwcdn.net/4EJR9/'
                      style={{ height: '100%' }}
                    />
                  </div>
                </div>
                <div className='graphicBox'>
                  <table className='ui small very basic compact collapsing table barChart'>
                    <tbody>
                      <tr>
                        <td className='seven wide'></td>
                        <td className='nine wide small'>Tote pro 100'000</td>
                      </tr>
                      <tr className='flu'>
                        <td className='seven wide'>∅ Grippe 2015&#x2011;19</td>
                        <td className='nine wide'>
                          <div className='barContainer'>
                            <div className='barChartWrapper'>
                              <div
                                className='barFlu'
                                style={{ width: 4.1 + '%' }}
                              ></div>
                            </div>
                            <div
                              className='value'
                              style={{ paddingLeft: 6.5 + '%' }}
                            >
                              2,6
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr className='covid'>
                        <td className='seven wide'>Covid-19 2020</td>
                        <td className='nine wide'>
                          <div className='barContainer'>
                            <div className='barChartWrapper'>
                              <div
                                className='barCovid'
                                style={{ width: 12.6 + '%' }}
                              ></div>
                            </div>
                            <div
                              className='value'
                              style={{ paddingLeft: 13 + '%' }}
                            >
                              7,9
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className='column special'>
                <div className='titleBox'>
                  <h4 className='ui infographic header'>Südafrika&nbsp;🇿🇦</h4>
                </div>
                <div className='boxWrapper'>
                  <div className='iframeBox'>
                    <AutofitIFrame
                      src='//datawrapper.dwcdn.net/KkUd3/'
                      style={{ height: '100%' }}
                    />
                  </div>
                </div>
                <div className='graphicBox'>
                  <table className='ui small very basic compact collapsing table barChart'>
                    <tbody>
                      <tr>
                        <td className='seven wide'></td>
                        <td className='nine wide small'>Tote pro 100'000</td>
                      </tr>
                      <tr className='flu'>
                        <td className='seven wide'>∅ Grippe 2015&#x2011;19</td>
                        <td className='nine wide'>
                          <div className='barContainer'>
                            <div className='barChartWrapper'>
                              <div
                                className='barFlu'
                                style={{ width: 13.3 + '%' }}
                              ></div>
                            </div>
                            <div
                              className='value'
                              style={{ paddingLeft: 13.8 + '%' }}
                            >
                              8,4
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr className='covid'>
                        <td className='seven wide'>Covid-19 2020</td>
                        <td className='nine wide'>
                          <div className='barContainer'>
                            <div className='barChartWrapper'>
                              <div
                                className='barCovid'
                                style={{ width: 42 + '%' }}
                              ></div>
                            </div>
                            <div
                              className='value'
                              style={{ paddingLeft: 34.8 + '%' }}
                            >
                              26,5
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Nun hofft man in Europa und den USA, dass die Entwicklung ähnlich
              verläuft und es keine zusätzliche Belastung des Gesundheitssystems
              durch die Grippe geben wird. Die These geht so: Da es nur sehr
              wenige Grippefälle auf der Südhalbkugel gab, können sie nun auch
              nur vereinzelt auf die Nordhalbkugel importiert werden.
            </p>
            <p>
              Allerdings sind in in den meisten Ländern, in denen der Winter
              kurz bevorsteht, nicht mehr so starke Eindämmungsregeln in Kraft.
              Das macht es nicht nur Sars-CoV-2 leichter, sich zu verbreiten,
              sondern allen anderen Viren auch. Um diesen Winter das
              Gesundheitswesen zu entlasten,{' '}
              <Link
                href='https://www.tagesanzeiger.ch/grippeimpfung-fuer-kinder-455822769537'
                allowWordWrap
              >
                lanciert der Bund deshalb eine neue Grippekampagne
              </Link>
              . Auch Kinder ab sechs Monaten sollen geimpft werden.
            </p>
            <div className='quote-element'>
              <p className='quote'>
                «Wenn es zu einer zweiten Corona-Welle kommt, dann erwarte ich,
                dass die Grippeviren verdrängt werden.»
              </p>
              <p className='quoteAuthor'>
                Hans Hirsch, Professor für Virologie und Infektiologe am
                Unispital Basel
              </p>
            </div>
            <p>
              Durch das fehlende Zirkulieren der Grippeviren in Australien oder
              Südafrika konnten Wissenschaftler auch die Frage nicht klären, wie
              sich Ko-Infektionen auswirken würden, also das gleichzeitige
              Erkranken an Grippe und Covid-19.
            </p>
            <p>
              Es gibt allerdings einige Hinweise. Forscher der Stanford
              University{' '}
              <Link href='https://med.stanford.edu/news/all-news/2020/03/covid-19-can-coexist-with-other-respiratory-viruses.html'>
                untersuchten
              </Link>{' '}
              im März in Kalifornien 49 Covid-Erkrankte und stellten fest, dass
              immerhin 11 gleichzeitig mit einem anderen Atemwegsvirus infiziert
              waren, beispielsweise mit Rhinoviren, RS-Viren oder anderen
              Coronaviren. Keine Person hatte aber zusätzlich die Grippe. Eine
              zusätzliche Infektion mit einem der Erreger hatte keinen Einfluss
              auf den Schweregrad der Covid-Erkrankung.
            </p>
            <p>
              Schon mehrere Untersuchungen stellten fest, dass Ko-Infektionen
              von Influenza-Viren und anderen respiratorischen Viren in der
              Normalbevölkerung eher selten sind – mit Ausnahme von stark
              immungeschwächten Personen. Es gibt also eine Form des Schutzes,
              wenn man bereits mit einem Influenza-Erreger infiziert ist. Die
              unspezifische Immunantwort bremst über Botenstoffe wie
              Typ-I-Interferone auch die Vermehrung von anderen Erkältungsviren.
            </p>
            <p>
              Bei Sars-CoV-2 könnte es ähnlich sein, wie{' '}
              <Link href='https://pubmed.ncbi.nlm.nih.gov/32726441/'>
                eine Studie
              </Link>{' '}
              von Forschern vom Basler Universitätsspital vergangenen März mit
              7000 Patienten zeigte, die sich im Spital wegen
              Atemwegsbeschwerden meldeten. Ganze 50 Prozent, bei denen eine
              respiratorische Virusinfektion festgestellt wurde, waren mit
              Sars-Cov-2 infiziert. Covid-19 drängte in der exponentiellen Phase
              der Epidemie damals Erkältungen und Grippe in den Hintergrund.
              Womöglich sinke die Wahrscheinlichkeit, sich eine Grippe zu holen,
              wenn man bereits mit Sars-CoV-2 infiziert sei, mutmassen die
              Studienautoren. Weniger als 2 Prozent der Corona-Infizierten
              litten zusätzlich noch an einer Grippe oder einer anderen
              respiratorischen Viruskrankheit.
            </p>
            <p>
              Studienleiter Hans Hirsch, Professor für Virologie und
              Infektiologe am Unispital Basel, rechnet für diesen Winter wieder
              mit einem ähnlichen Szenario: «Wenn es zu einer zweiten
              Corona-Welle kommt, dann erwarte ich, dass die Grippeviren
              verdrängt werden.» Anders sehe es möglicherweise bei Kindern aus,
              die sich eher mit RS-Viren oder Metapneumoviren infizierten, diese
              würden dann unter Umständen Sars-Infektionen seltener machen.
              «Wenn jetzt allerdings auch Kinder verbreiteter an Covid-19
              erkranken, werden es auch bei ihnen andere Winterviren schwerer
              haben.»
            </p>
            <p>
              Die Wahrscheinlichkeit einer gleichzeitigen Infektion von
              Sars-CoV-2 und Influenza schätzt Hirsch als gering ein. Wenn es
              doch dazu käme, wäre der Schweregrad des Verlaufs von den
              Wirtsfaktoren und dem individuellen Immunitätsgedächtnis abhängig.
              «Wenn ich von unserer Studie extrapolieren darf, würde ich beim
              normalen Erwachsenen eher erwarten, dass meist Sars-CoV-2 das
              Rennen macht», sagt Hirsch.
            </p>
            <p>
              Es gibt also für die Nordhalbkugel berechtigte Hoffnung, keine
              schwere Grippesaison zu erleben in den kommenden Monaten. Das
              Problem ist aber nicht aufgehoben, sondern womöglich nur
              aufgeschoben. Denn je länger die Menschen nicht mehr mit
              Influenza-Viren in Kontakt kommen, desto stärker nimmt auch die
              Immunität ab. Hirsch sagt dazu: «Das ist tatsächlich eine wichtige
              Überlegung. Wenn wir rückblickend die Influenza-Viren der letzten
              10 Jahre anschauen, sehen wir, dass sich die 4 Typen A/H1N1,
              A/H3N2, B-Yamagata und B-Victoria regelmässig abwechseln.» Das
              spreche dafür, dass immer jener Strang dominiere, gegen den es am
              wenigsten Immunität in der Bevölkerung gebe.
            </p>
            <p>
              Ende nächstes Jahr werden also unter Umständen mehr Personen
              anfällig für eine Grippe sein, womöglich steht uns dann ein
              weiterer harter Winter bevor.
            </p>
          </div>
        </div>
      </div>

      <Footer
        articleId={ARTICLE_ID}
        questions={[
          'Wie informativ war der Beitrag?',
          'Wie verständlich waren die Grafiken?'
        ]}
        credits={[
          ['Konzept und Umsetzung', 'Marc Brupbacher, Patrick Vögeli'],
          [
            'Quellen',
            '<a href="https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(17)33293-2/fulltext#:~:text=Introduction,-Annual%20influenza%20epidemics&text=Influenza%20(seasonal)%20fact%20sheet.&text=indicated%20that%20250%20000%E2%80%93500,Social%20Affairs%20World%20Population%20Prospects">«Estimates of global seasonal influenza-associated respiratory mortality»</a>, <a href="https://www.who.int/influenza/gisrs_laboratory/flunet/en/">WHO</a>, Johns Hopkins University, <a href="https://www.economist.com/graphic-detail/2020/09/12/the-southern-hemisphere-skipped-flu-season-in-2020">«The Economist», The southern hemisphere skipped flu season in 2020</a>'
          ],
          [
            'Inspiration',
            '<a href="https://www.economist.com/graphic-detail/2020/09/12/the-southern-hemisphere-skipped-flu-season-in-2020">«The Economist», The southern hemisphere skipped flu season in 2020</a>'
          ]
        ]}
      />
    </div>
  )
}
